<div *ngIf="!generatePnr" class="col-md-12 row " [style]="isActive('/app/buslist')?('background-color: #06497286; padding-bottom: 70px;min-width: 1300px;'):isActive('/app/buslist')?('background-color: transparent; padding-bottom: 70px;min-width: 1300px;'):isActive('/app/flight-intl-list')?('background-color: transparent; padding-bottom: 70px;min-width: 1300px;'):'background-color: transparent; padding-bottom: 50px;min-width: 1200px;' " >
    <div class="col-md-12" *ngIf="!isActive('/app/buslist')&&!isActive('/app/create-manual-cart')&&!isActive('/app/flight-intl-list')">

    <div class="outside-container  mainDiv" >

        <div class="box-container col-md-8"  style="min-width: 700px;">

                <div class="container "  >
  <app-booking-menu-list></app-booking-menu-list>
  </div> 
 </div>
</div>
</div>


  
  <div class="col-md-12 " >
    
      <div class="outside-container " [style]="isActive('/app/flight-intl-list')?('padding-top: 0; margin-top: -25px;'):isActive('/app/buslist')?('padding-top: 0; margin-top: -25px;'):isActive('/app/buslist')?('padding-top: 0; margin-top: -25px;'):isActive('/app/flight-intl-list')?('padding-top: 0; margin-top: -25px;'):''">

        <div class="box-container design" style="padding-bottom: 30px;">

                  <div class="container">
                    
                    
                      <br>
                      <br>

                      <div class="row col-md-12 ">
                        <!-- <form *ngIf="!isActive('/app/buslist')" [formGroup]="searchFg" class="col-md-6" action="">
                       
                        <mat-radio-group color="primary" aria-label="Select an option" (change)="onMenuChange($event)"  formControlName="menu">
                            <mat-radio-button  value="I">International</mat-radio-button>
                            <mat-radio-button  value="D">Domestic</mat-radio-button>

                          </mat-radio-group>
                          
                         
                    </form> -->

                    
                          <div class="col-md-6">
                              <div  *ngIf="selectedDetail" class="card shadow col-md-3" [style]="isActive('/app/flight-intl-list')?('height:300px; position: absolute ; right:12%;top:12%; z-index: 2;min-width:350px ;'):isActive('/app/buslist')?('height:300px; position: absolute ; right:12%;top:12%; z-index: 2;min-width:350px ;'):isActive('/app/buslist')?(' height:300px; position: absolute ; right:12%;top:12%; z-index: 2;min-width:350px ;'):'height:300px; position: absolute ; right:12%;top:36%; z-index: 2;min-width:350px ;'" >
                                          <div>
                                          <button type="button" class="close" data-dismiss="modal" (click)="closeDetail()">&times;</button>
                                          </div>
                                          <div class="row col-md-12 mt-2 d-flex justify-content-center">
                                              <div class="col-md-4 bold d-flex justify-content-start"  >Persons </div>
                                              <div class="col-md-2 " >
                                              <button (click)="decrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
                                              </div >{{ currentNumber }}
                                              <div class="col-md-2">
                                              <button (click)="increment()" class="circle-button">
                                              <span class="plus-icon pb-1">+</span>
                                              </button>
                                              </div> 
                                          </div>
                                    <div class="mt-4 d-flex justify-content-center" >
                                          <div class="col-md-10 row ">
                                            <div class="col-md-6 mt-2" *ngFor="let item of dobArray ;let i=index">
                                                <mat-label class="bold d-flex justify-content-start" style="text-align: start;">DOB <small>(Person {{i+1}})</small></mat-label>
                                                <input type="date" [max]="max" [(ngModel)]="item.dob" class="form-control">
                                              
                                            </div>
                                          </div>  
                                        </div>                                                                                 
                              </div>
                      </div>
                      </div>
                      <div   [class]="!isActive('/app/flight-intl-list')?('mt-2  col-md-12 d-flex justify-content-center'):!isActive('/app/buslist')?('mt-2  col-md-12 d-flex justify-content-center'):!isActive('/app/buslist')?('mt-2  col-md-12 d-flex justify-content-center'):'mt-2 row col-md-12'" style="padding-left:12px ;">

                          <div  class="col-md-8 border "  [style]="showOneWay?('display:block;border-radius: 4px; padding: 4px;background-color:white'):'display:none;'&&showReturn?('display:block;border-radius: 4px; padding: 4px;background-color:white'):'display:none;'">
                                 <img *ngIf="showSearch" style="max-width: 100px;" src="../../../assets/images/time.gif" alt="">
                            <form [formGroup]="searchFg"  *ngIf="!showSearch" class="row">  

                                  
                  
                                    <div class="col-md-4 "   style="border-right:1px solid #DEE2E6 ;text-align: left;" >
                                        <!-- <mat-icon matSuffix>flight_takeoff</mat-icon> -->
                                
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">From</mat-label>
                                       <div></div>
                                        <span *ngIf="!isActive('/app/buslist')" class="bold col-md-12" [style]="!isActive('/app/buslist')?('font-size: 20px;'):!isActive('/app/buslist')?('font-size: 20px;'):!isActive('/app/flight-intl-list')?('font-size: 20px;'):'font-size: 20px;'" >&nbsp;{{departure}}</span>
                                        <ng-select
                                        class="classSelection"

                                        [items]="list"
                                        [(ngModel)]="selectedCityObject"
                                        [ngModelOptions]="{standalone: true}"
                                        bindLabel="cityLabel"
                                        [searchable]="true"
                                        [virtualScroll]="true"
                                        (change)="selected($event)"
                                      >
                                        <ng-template ng-option-tmp let-item="item" >
                                           {{ item.cityLabel }}
                                        </ng-template>
                                      </ng-select>
                                        <small *ngIf="fromAirportError" class="warn">Please select flight details!</small>
                        
                                    </div>
                
                                    <div class="col-md-4 " style="border-right:1px solid #DEE2E6 ;text-align: left;"  >
                                        <!-- <mat-icon matSuffix>flight_land</mat-icon> -->
                            
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">To</mat-label>
                                        <div></div>
                                        <span *ngIf="!isActive('/app/buslist')" class="bold col-md-12" [style]="!isActive('/app/buslist')?('font-size: 20px;'):'font-size: 20px;'">&nbsp;{{arrivel}}</span>
                                        
                                        <ng-select
                                        class="classSelection"
                                        [items]="list"
                                        bindLabel="cityLabel"
                                        [(ngModel)]="selectedToCityObject"
                                        [ngModelOptions]="{standalone: true}"
                                        [searchable]="true"
                                        (change)="selectedTo($event)"
                                        [virtualScroll]="true"
                                      
                                      >
                                        <ng-template ng-option-tmp let-item="item" >
                                           {{ item.cityLabel }}
                                        </ng-template>
                                      </ng-select>
                                        <small *ngIf="toAirportError" class="warn">Please select flight details!</small>
                                    </div>
                                  
                              
                                      <div class="col-md-4" style="text-align: left;cursor: pointer" (click)="pickers.open()">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">Departure Date</mat-label>
                                              <input class="mainbox"  style="color: transparent;padding: 0;margin: 0; font-size: 1px;" formControlName="requestedDate" readonly [min]="minData" [matDatepicker]="pickers"  (dateChange)="onOneWayDate()">
                                            <div class="col-md-12" *ngIf="!isActive('/app/buslist')">
                                              <span class=" bold" [style]="!isActive('/app/buslist')?('font-size: 25px;'):!isActive('/app/buslist')?('font-size: 25px;'):!isActive('/app/flight-intl-list')?('font-size:25px'):'font-size: 20px;'">{{departureTime[0]}}</span>&nbsp;&nbsp;<span  [style]="!isActive('/app/buslist')?('font-size: 23px;'):'font-size: 18px;'">{{departureTime[1]}}</span><span  [style]="!isActive('/app/buslist')?('font-size: 25px;'):'font-size: 20px;'">{{departureTime[2]?("'"+departureTime[2]):''}}</span>
                                              <br><span class=" bold" style="font-size: 15px; ">{{departureTime[3]}}</span>
                                            </div>
                                            <div *ngIf="isActive('/app/buslist')" >
                                                <span class="bold"> {{departureTime}}</span> 
                                               </div>
                                              <mat-datepicker #pickers ></mat-datepicker>
                                      </div>
                                  
                                     
                                    
                                  </form>           
                              </div>
                             
                              <div *ngIf="!showSearch">
                                <button style="width: 100%; border-radius: 10px; background-color: #017BFE;color: #fff;height: 60px;margin-left: 4px;" mat-flat-button  (click)="searchFlight()" >
                                <span class="bold" style="font-size: xx-large;">SEARCH</span>
                                </button>  
                              </div>  
                      </div>
                  
                     <div *ngIf="showPnrRetrieval">
                        <app-manual-cart></app-manual-cart>

                     </div>

                   
                    </div> 

              </div> 
             
      </div>
  </div>
</div>


<div *ngIf="generatePnr" class="col-md-12 " >
    <app-generate-pnr (myOutput)="GetChildData()" ></app-generate-pnr>
</div>
<span *ngIf="!isActive('/app/create-manual-cart')">
<!-- <app-offers *ngIf=" !isActive('/app/buslist')&& !isActive('/app/buslist')"></app-offers> -->
</span>